import {Form} from "react-final-form";
import SubjectField from "../../FinalForm/api/SubjectField";

import React from "react";
import Widget from "../../components/widget";


export const Filter = ({getEvent}) => {
    return (
        <Widget>
            <div className={"flex flex-col"}>
                <Form onSubmit={getEvent}
                      render={({handleSubmit}) => (
                          <form className="form flex flex-wrap w-full">
                              <div className="w-full flex">
                                  <div className={"w-1/2"}>
                                      <SubjectField name={"subjectId"} label={"Vyberte subjekt"}
                                                    validate={value => !value}
                                                    onEnter={() => handleSubmit()} onChange={() => handleSubmit()}
                                                    filters={{isArenaMode: true}}/>
                                  </div>
                              </div>
                          </form>
                      )}
                />
            </div>
        </Widget>
    )
}
